import React from 'react';
import { loadProfilePhoto } from '../utils/profilePhotoStorage';

/**
 * Sidebar/header avatar — uses uploaded profile photo when available.
 */
export default function PortalAvatar({ userId, name, photoUrl, size = 36, style, className }) {
  const photo = photoUrl || loadProfilePhoto(userId);
  const initial = (name || 'U').trim().charAt(0).toUpperCase();
  const px = typeof size === 'number' ? size : 36;

  if (photo) {
    return (
      <img
        src={photo}
        alt=""
        className={className}
        style={{
          width: px,
          height: px,
          borderRadius: '50%',
          objectFit: 'cover',
          border: '2px solid rgba(201,168,76,0.45)',
          flexShrink: 0,
          ...style,
        }}
      />
    );
  }

  return (
    <div
      className={className}
      style={{
        width: px,
        height: px,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #a07830, #e2c97e)',
        color: '#0a1628',
        fontWeight: 900,
        fontSize: Math.round(px * 0.38),
        flexShrink: 0,
        ...style,
      }}
    >
      {initial}
    </div>
  );
}
